<template>
  <!--==================
    component shows tour activity (admin)
    ===============-->

  <div class="col-12 pb-20 pt-20 px-0">
    <button @click="showAddModal" class="btn btn-sm btn-primary ml-2 mr-2 mb-4">Add Activity</button>
    <div class="card">
      <div class="table-responsive">
        <table class="table table-sm table-nowrap card-table">
          <thead class="text-primary">
            <tr>
              <th>#</th>
              <th>TITLE</th>
              <th>DESCRIPTION</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!tourActivities.length" class="text-center">
              <td colspan="4">
                <span class="text-muted"><em>Data not found</em></span>
              </td>
            </tr>
            <tr v-for="(tour, index) in tourActivities" :key="tour.id">
              <td :id="'row-' + tour.id">{{ index + 1 }}</td>
              <td class="text-left">{{ tour.name }}</td>
              <td class="text-left" style="width: 200px; white-space: pre-wrap">
                <span v-if="tour.description != null">{{ tour.description }}</span>
                <em class="text-muted" v-else>No description</em>
              </td>
              <td class="text-left">
                <button @click="edit($event)" class="btn btn-sm btn-primary ml-2 mr-2" :data-id="tour.id">Edit</button>
                <button
                  @click="remove($event)"
                  class="btn btn-sm btn-danger ml-2"
                  :data-id="tour.id"
                  :data-index="tour.id"
                >
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Add Modal -->
    <div
      class="modal fade"
      id="add-activity"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header py-3">
            <h5 class="modal-title">
              <strong>ADD ACTIVITY</strong>
            </h5>
            <button @click="closeAddModal()" type="button" aria-label="Close" class="close">
              <span aria-hidden="true"><i class="icofont-close-circled text-danger"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <form class="col" @submit.prevent="addActivity">
              <div class="form-group col">
                <input
                  v-model="title"
                  type="text"
                  name="title"
                  placeholder="title"
                  class="form-control form-control-sm"
                  required
                />
              </div>
              <div class="form-group col">
                <textarea
                  id="description"
                  rows="4"
                  name="description"
                  placeholder="description"
                  class="form-control form-control-sm"
                  v-model="description"
                  required
                ></textarea>
              </div>
              <div class="form-group col text-center">
                <button type="submit" class="btn btn-success btn-sm col-4">
                  <span v-if="!isAdding">ADD</span>
                  <span v-else>ADDING...</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Modal -->
    <div
      class="modal fade"
      id="edit-activity"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header py-3">
            <h5 class="modal-title"><strong>EDIT ACTIVITY</strong></h5>
            <button @click="closeEditModal()" type="button" aria-label="Close" class="close">
              <span aria-hidden="true"><i class="icofont-close-circled text-danger"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <form class="col" @submit.prevent="updateActivity">
              <div class="form-group col">
                <input
                  v-model="title"
                  type="text"
                  name="title"
                  placeholder="title"
                  class="form-control form-control-sm"
                  required
                />
              </div>
              <div class="form-group col">
                <textarea
                  id="description"
                  rows="4"
                  name="description"
                  placeholder="description"
                  class="form-control form-control-sm"
                  v-model="description"
                  required
                ></textarea>
              </div>
              <div class="form-group col text-center">
                <button type="submit" class="btn btn-success btn-sm col-4">
                  <span v-if="!isUpdating">UPDATE</span>
                  <span v-else>UPDATING...</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TourActivity",

  data() {
    return {
      title: "",
      description: "",
      id: 0,
      isAdding: false,
      isUpdating: false,
    };
  },

  computed: {
    ...mapGetters(["tourActivities"]),
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await this.fetchTourActivities();
      this.hideBarLoading();
    });
  },

  methods: {
    ...mapActions([
      "fetchTourActivities",
      "createTourActivity",
      "updateTourActivity",
      "deleteTourActivity",
      "hideBarLoading",
    ]),

    showAddModal() {
      this.title = "";
      this.description = "";
      $("#add-activity").modal("show");
    },

    closeAddModal() {
      $("#add-activity").modal("hide");
    },

    showEditModal() {
      $("#edit-activity").modal("show");
    },

    closeEditModal() {
      $("#edit-activity").modal("hide");
    },

    remove(e) {
      const id = e.target.getAttribute("data-id");
      const dP = this;

      $.confirm({
        title: "",
        content: "Are you sure want to delete this activity ?",
        buttons: {
          confirm: async () => {
            await dP.deleteTourActivity(id);
            dP.fetchTourActivities();
          },
          cancel: () => {},
        },
      });
    },

    edit(e) {
      const id = e.target.getAttribute("data-id");
      this.id = id;
      this.title = this.tourActivities.find((x) => x.id == id).name;
      this.description = this.tourActivities.find((x) => x.id == id).description;
      this.showEditModal();
    },

    async addActivity() {
      const data = {
        inputId: this.title.replace(/\s+/g, "-").toLowerCase(),
        name: this.title,
        description: this.description,
      };
      this.isAdding = true;
      await this.createTourActivity(data).then(async () => {
        this.isAdding = false;
        await this.fetchTourActivities();
        $("#add-activity").modal("hide");
      });
    },

    async updateActivity() {
      const data = {
        inputId: this.title.replace(/\s+/g, "-").toLowerCase(),
        name: this.title,
        description: this.description,
        id: this.id,
      };
      this.isUpdating = true;
      await this.updateTourActivity(data, this.id).then(async () => {
        this.isUpdating = false;
        await this.fetchTourActivities();
        $("#edit-activity").modal("hide");
      });
    },
  },
};
</script>